import GroupDropdown from "pagesV2/pro/clients/ClientWindow/GroupManager"
import { Modal } from "ui/Modal"
import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"
import PropTypes from "prop-types"

const ClientGroupManage = ({
  groupAction,
  isGroupModalVisible,
  setIsGroupModalVisible,
  selectedClient,
  selectedClientIds,
  groups,
  handleSelectedGroupsChange,
  handleGroupActionClick,
  hideMenuList,
  setSelectedClientIds,
  selectedGroups,
  handleCancelGroupAction
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      width={{ xxl: 800, xl: 700 }}
      title={
        groupAction === "bulk_add" || groupAction === "add"
          ? t("clients.bulk_actions.add_to_group")
          : t("clients.bulk_actions.remove_from_group")
      }
      open={isGroupModalVisible}
      footer={null}
      onCancel={handleCancelGroupAction}
      destroyOnClose
    >
      <GroupDropdown
        action={groupAction}
        menuState={true}
        hideMenuList={hideMenuList}
        client={selectedClient}
        selectedClientIds={selectedClient ? undefined : selectedClientIds}
        groups={groups}
        setIsGroupModalVisible={setIsGroupModalVisible}
        selectedGroups={selectedClient?.client_groups || selectedGroups || []}
        onSelectedGroupsChange={handleSelectedGroupsChange}
        moduleName={"client"}
        setSelectedClientIds={setSelectedClientIds}
      />
      <Flex gap={12} className="my-xl">
        <Button variant="outlined" color="primary" onClick={handleCancelGroupAction}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleGroupActionClick}>
          Save
        </Button>
      </Flex>
    </Modal>
  )
}

ClientGroupManage.propTypes = {
  groupAction: PropTypes.string,
  isGroupModalVisible: PropTypes.bool,
  setIsGroupModalVisible: PropTypes.func,
  selectedClient: PropTypes.object,
  selectedClientIds: PropTypes.array,
  groups: PropTypes.array,
  handleSelectedGroupsChange: PropTypes.func,
  handleGroupActionClick: PropTypes.func,
  hideMenuList: PropTypes.bool,
  setSelectedClientIds: PropTypes.func,
  selectedGroups: PropTypes.array,
  handleCancelGroupAction: PropTypes.func
}

export default ClientGroupManage
